export const config = {
  title: 'JQ Construction LLC',
  meta: {
    description:
      'JQ Construction LLC offers premier renovation and construction services in Plainfield, NJ, specializing in bathroom design, remodeling, and luxury upgrades.',
    keywords: [
      'Renovation Services',
      'Construction Services',
      'Bathroom Design',
      'Bathroom Remodeling',
      'Luxury Bathroom Upgrades',
      'Accessible Bathroom Modifications',
      'JQ Construction LLC',
      'Plainfield NJ Construction',
      'Home Improvement',
      'MyBizSolutions LLC',
      'BizSolutions LLC'
    ],
    author: 'JQ Construction LLC',
    canonicalUrl: 'https://jqconstructionllc.com/',
  },
  sections: {
    header: {
      businessName: 'JQ Construction LLC',
    },
    sectionB: {
      heroTitle: 'JQ Construction LLC',
      heroSubtitle: 'Transforming Homes with Expert Renovation & Construction Services',
      learnAboutText: 'Learn About Our Services',
      phoneNumber: '9084490877',
      phoneLabel: '(908) 449-0877',
      heroBackgroundImage:
        'https://media.istockphoto.com/id/871613220/photo/renovate-and-repair-residential-house-facade-wall-with-mineral-wool-insulation-plastering.jpg?s=612x612&w=0&k=20&c=5ydAdDldJPPcKJiniVRZxUFV16Sk7Ve6-fZmEsWyXVU=',
      cardData: [
        {
          title: 'Design Excellence',
          description:
            'Our design expertise brings your dream bathroom to life, reflecting your unique style and personality.',
        },
        {
          title: 'Quality Construction',
          description:
            'We maintain open communication throughout the construction phase, ensuring your project progresses smoothly.',
        },
        {
          title: 'Interior Transformation',
          description:
            'Our team creates cohesive and captivating interiors, turning your bathroom into a comfortable retreat.',
        },
      ],
      description:
        'At JQ Construction LLC, we specialize in bathroom design and planning, renovation and remodeling, accessible modifications, and luxury upgrades. Serving Plainfield, NJ, and surrounding areas, we are committed to delivering high-quality workmanship and customer satisfaction.',
    },
    sectionC: {
      servicesTitle: 'Our Services',
      servicesDescription:
        'Explore our range of professional services designed to enhance your home.',
      cards: [
        {
          title: 'Bathroom Design and Planning',
          description:
            'Crafting designs that maximize aesthetics and functionality, tailored to your vision and lifestyle.',
          imageSrc: 'https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/Tv4d6pkOPLy7N01rL3sN/media/20a71729-ae4b-4910-b241-8f0cb34cd2fb.jpeg',
          imageAlt: 'Bathroom Design and Planning',
        },
        {
          title: 'Bathroom Renovation and Remodeling',
          description:
            'Handling everything from structural modifications to updating fixtures and finishes for a fantastic and efficient bathroom.',
          imageSrc: 'https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/Tv4d6pkOPLy7N01rL3sN/media/4dc05a6f-8d50-465c-b92e-e39dcfe176d4.jpeg',
          imageAlt: 'Bathroom Renovation and Remodeling',
        },
        {
          title: 'Accessible Bathroom Modifications',
          description:
            'Providing functional and attractive solutions to enhance independence and comfort in your bathroom.',
          imageSrc: 'https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/Tv4d6pkOPLy7N01rL3sN/media/e76b3993-40cc-432f-8b35-d8ca8f5e3ee5.jpeg',
          imageAlt: 'Accessible Bathroom Modifications',
        },
      ],
      otherServicesTitle: 'Additional Services',
      otherServicesList: [
        'Luxury Bathroom Upgrades',
        'Kitchen Remodeling',
        'Basement Finishing',
        'Home Additions',
        'Custom Carpentry',
      ],
    },
    sectionD: {
      aboutTitle: 'About Us',
      aboutImage: {
        src: 'https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/Tv4d6pkOPLy7N01rL3sN/media/fde89359-669d-418e-8c07-e22679f0952c.jpeg',
        alt: 'JQ Construction LLC Team',
      },
      aboutText: [
        'JQ Construction LLC is a family-owned company serving Plainfield, NJ, and surrounding areas. We are known for our experience and professionalism, providing clients with top-of-the-line services that cater to their specific project needs.',
        'Our mission is to deliver exceptional renovation and construction services with a commitment to quality and customer satisfaction.',
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: 'JQ Construction LLC Logo',
      businessName: 'JQ Construction LLC',
      contact: {
        phone: '9084490877',
        phoneLabel: '(908) 449-0877',
        email: 'info@jqconstructionllc.com',
        website: 'https://jqconstructionllc.com/',
        address: '107 Crescent Ave, Plainfield, NJ 07060',
      },
      socialMedia: {
        facebook: 'https://www.facebook.com/JQConstructionLLC',
        instagram: 'https://www.instagram.com/JQConstructionLLC/',
        linkedin: 'https://www.linkedin.com/company/jq-construction-llc/',
        twitter: 'https://twitter.com/JQConstructionLLC',
        youtube: 'https://www.youtube.com/channel/UCJQConstructionLLC',
      },
    },
    sectionF: {
      address: '107 Crescent Ave, Plainfield, NJ 07060',
      googleMapsEmbedUrl:
        'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3023.123456789012!2d-74.4123456!3d40.6123456!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e7ab1234567890%3A0xabcdef1234567890!2s107%20Crescent%20Ave%2C%20Plainfield%2C%20NJ%2007060!5e0!3m2!1sen!2sus!4v1710407450828!5m2!1sen!2sus',
    },
  },
};

export default config;
